/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMoneyCheckEditAlt} from '@fortawesome/pro-duotone-svg-icons';

const GrantsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faMoneyCheckEditAlt} {...props} />
);

export default GrantsIcon;
